<template>
  <div class="dateselect">
    <select
      id="dateselectyear-nonlimit"
      v-model="year"
      @change="getMonthOptions()"
      class="col-md-2 dateselect__inputField"
      :class="yearSelected"
      @focus="setStyle(1)"
    >
      <option v-for="year in years" :value="year">{{ year }}年</option>
    </select>
    <select
      id="dateselectmonth-nonlimit"
      v-model="month"
      @change="getDayOptions()"
      class="col-md-2 dateselect__inputField"
      :class="monthSelected"
      @focus="setStyle(2)"
    >
      <option v-for="month in months" :value="month">{{ month }}月</option>
    </select>
    <select
      id="dateselectdate-nonlimit"
      v-model="day"
      class="col-md-2 dateselect__inputField"
      :class="dateSelected"
      @focus="setStyle(3)"
      @change="getWeekChange()"
    >
      <option v-for="day in days" :value="day">{{ day }}日</option>
    </select>
    <select
      id="dateselecthour-nonlimit"
      v-model="hour"
      class="col-md-2 dateselect__inputField"
      :class="hourSelected"
      @focus="setStyle(4)"
    >
      <option v-for="hour in hours" :value="hour">{{ hour }}時</option>
    </select>
    <select
      id="dateselectminute-nonlimit"
      v-model="minute"
      @change="getDate()"
      class="col-md-2 dateselect__inputField"
      :class="minuteSelected"
      @focus="setStyle(5)"
    >
      <option v-for="minute in minutes" :value="minute">{{ minute }}分</option>
    </select>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  data() {
    return {
      years: [],
      months: [],
      days: [],
      hours: [],
      minutes: [],
      year: moment().year(),
      month: moment().month() + 1,
      day: moment().date(),
      hour: 0,
      minute: 0,
      yearSelected: 'nonyellow',
      monthSelected: 'nonyellow',
      dateSelected: 'nonyellow',
      hourSelected: 'nonyellow',
      minuteSelected: 'nonyellow',
    }
  },
  methods: {
    getYearOptions() {
      this.years.push(moment().year() + 1)
      this.years.push(moment().year())
      if (moment().month() - 11 < 0) {
        this.years.push(moment().year() - 1)
      }
      this.getMonthOptions()
    },
    getMonthOptions() {
      this.months = []
      for (var i = 0; i < 12; i++) {
        this.months.push(i + 1)
      }
      this.getDayOptions()
    },
    getDayOptions() {
      let startDate = moment([this.year, this.month - 1])
      // console.log(typeof(moment(startDate).endOf('month').format("DD")))
      let endDate = moment(startDate).endOf('month').format('DD')
      let int_endDate = parseInt(endDate)
      this.days = []
      for (var i = 0; i < int_endDate; i++) {
        this.days.push(i + 1)
      }
      let week = this.getWeek()

      this.$emit('week-data', week)
    },
    getHourOptions() {
      this.hours = []
      for (let hour_i = 0; hour_i < 24; hour_i++) {
        this.hours.push(hour_i)
      }
    },
    getMinuteOptions() {
      this.minutes = []
      for (let minute_i = 0; minute_i < 60; minute_i++) {
        this.minutes.push(minute_i)
      }
    },
    getDate() {
      // console.log(`${this.year}-${this.month}-${this.day} ${this.hour}:${this.minute}`)
      return moment(
        `${this.year}-${this.month}-${this.day} ${this.hour}:${this.minute}`,
      ).format('YYYY-MM-DD HH:mm:ss')
    },
    getWeek() {
      let weekNumber = moment(
        `${this.year}-${this.month}-${this.day} ${this.hour}:${this.minute}`,
      ).format('d')
      let weekArray = {
        0: '星期日',
        1: '星期一',
        2: '星期二',
        3: '星期三',
        4: '星期四',
        5: '星期五',
        6: '星期六',
      }
      return weekArray[weekNumber]
    },
    getWeekChange() {
      let week = this.getWeek()
      this.$emit('week-data', week)
    },
    setStyle(num) {
      ;(this.yearSelected = 'nonyellow'),
        (this.monthSelected = 'nonyellow'),
        (this.dateSelected = 'nonyellow'),
        (this.hourSelected = 'nonyellow'),
        (this.minuteSelected = 'nonyellow')
      switch (num) {
        case 1:
          this.yearSelected = 'yellow'
          break
        case 2:
          this.monthSelected = 'yellow'
          break
        case 3:
          this.dateSelected = 'yellow'
          break
        case 4:
          this.hourSelected = 'yellow'
          break
        case 5:
          this.minuteSelected = 'yellow'
          break
      }
    },
    resetTime() {
      ;(this.year = moment().year()), (this.month = moment().month() + 1)
      this.day = moment().date()
      this.hour = 0
      this.minute = 0
      ;(this.yearSelected = 'nonyellow'),
        (this.monthSelected = 'nonyellow'),
        (this.dateSelected = 'nonyellow'),
        (this.hourSelected = 'nonyellow'),
        (this.minuteSelected = 'nonyellow')
    },
  },
  mounted() {
    this.getYearOptions()
    this.getHourOptions()
    this.getMinuteOptions()
    this.getMinuteOptions
  },
}
</script>
<style scoped lang="scss">
.dateselect {
  &__inputField {
    height: 36px;
    padding: 6px 12px;
    font-size: 16px;
    color: #555;
    border: 1px solid #ccc;
    border-radius: 4px;
    margin-right: 10px;
  }
}
.yellow {
  background: yellow;
}
.nonyellow {
  background: white;
}
</style>



// WEBPACK FOOTER //
// src/components/tool/DateSelectNonLimit.vue